export default "__VITE_ASSET__UdYRo1Xf__"